/**
 * Resize an image File to a max long-edge of 1600px, JPEG quality 0.8.
 * Returns a base64 data URL. Cancels gracefully if the file isn't an image.
 */
export async function resizeImageFile(file: File, maxEdge = 1600, quality = 0.8): Promise<string> {
  if (!file.type.startsWith('image/')) {
    throw new Error(`Not an image: ${file.type}`);
  }
  const bitmap = await createImageBitmap(file);
  const { width: w, height: h } = bitmap;
  let targetW = w;
  let targetH = h;
  const longEdge = Math.max(w, h);
  if (longEdge > maxEdge) {
    const scale = maxEdge / longEdge;
    targetW = Math.round(w * scale);
    targetH = Math.round(h * scale);
  }
  const canvas = document.createElement('canvas');
  canvas.width = targetW;
  canvas.height = targetH;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');
  ctx.drawImage(bitmap, 0, 0, targetW, targetH);
  bitmap.close?.();
  return canvas.toDataURL('image/jpeg', quality);
}
